import React from 'react'

function scaleProps (n) {
  return {
    width: n * 10,
    height: n * 10
  }
}

const ListView = ({ color, scale, style, onClick, className }) => (
  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" className={className} style={{...style, ...scaleProps(scale)}} onClick={onClick}>
    <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Dashboard---Portfolio-Grid" transform="translate(-1300.000000, -324.000000)" fill={color}>
        <g id="Group-9" transform="translate(1300.000000, 324.000000)">
          <g id="Group-3-Copy-6">
            <rect id="Rectangle-Copy-10" x="0" y="0" width="30" height="6" rx="1"></rect>
          </g>
          <g id="Group-3-Copy-9" transform="translate(0.000000, 12.000000)">
            <rect id="Rectangle-Copy-10" x="0" y="0" width="30" height="6" rx="1"></rect>
          </g>
          <g id="Group-3-Copy-10" transform="translate(0.000000, 24.000000)">
            <rect id="Rectangle-Copy-10" x="0" y="0" width="30" height="6" rx="1"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default ListView